import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import ReactSelect from "react-select";
import SoftBox from "components/SoftBox";
import { useAgencyInfo } from "context/agency";
import { useCreateAssistant, useCreateAssistantTemplate } from "queries/assistants";
import { useSaveAssistantMultimedia } from "queries/chat";
import { useAgentBuilderData } from "queries/agency";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import infoimg from "../../info.png";
import axios from "axios";
import SoftTypography from "components/SoftTypography";
import ModelPromptslabels from "../../../UiPrompts/promptlabels/ModelPrompts/Create";
import { Tooltip } from "@mui/material";
import AnimatedText from "layouts/super-admin/components/Animation/AnimatedText";
import LoadingDots from "layouts/super-admin/components/Animation/LoadingDots";
import Icon from "layouts/super-admin/components/Icon";
import { Switch, Button, TextField } from "@mui/material";
import AttachmentIcon from "@mui/icons-material/Attachment";
import MyDropzone from "../../MyDropzone";
import localforage from "localforage";
import env from "config/env";

function ModalComponent({ open, onClose, handleRefresh, supperAdminData, pluginsdata }) {
  const request = useRequest();
  const [agency] = useAgencyInfo();
  const [contentCreativity, setContentCreativity] = useState(1);
  const [btgen, setBtgen] = useState(1);
  const [waiting, setWaiting] = useState(false);
  const [promptQuery, setPromptQuery] = useState("");
  const [promptstep, setpromptstep] = useState(0);
  const [promptQueryError, setPromptQueryError] = useState("");
  const [FormData1, setFormData1] = useState([]);
  const [showStep, setshowStep] = useState(false);
  const [apiType, setapiType] = useState("");
  const [isForSupport, setIsForSupport] = useState(false);
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [alertModel, setAlertModel] = useState(false);

  const handleIsSupportCheck = (e) => {
    setIsForSupport(e.target.checked);
  };

  const { mutateAsync: createAssistant } = useCreateAssistant();
  const { mutateAsync: createAssistantTemplate } = useCreateAssistantTemplate();
  const saveAssistantMultimedia = useSaveAssistantMultimedia();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!e.target.assistant_type.value) {
      alert("Please select an Agent type");
      return true;
    }
    let requestrunner;

    if (
      e.target.assistant_type.value === "agency" ||
      e.target.assistant_type.value === "automation"
    ) {
      setWaiting(true);
      const payload = {
        name: FormData1.promptName,
        instructions: FormData1.description,
        model: "openai/gpt-4o",
        temperature: contentCreativity,
        top_p: btgen,
        agency_id: agency._id,
        profile_id: agency._id,
        readonly: true,
        type: "agency",
        status: false,
        assist_type: e.target.assistant_type.value === "agency" ? "agency" : "automation",
        for_support: e.target.assistant_type.value === "automation" ? true : false,
        advanceConversationMode: advanceConversationMode,
        numberOfMessages: numberOfMessages,
        messageDelayTime: messageDelayTime,
        function_names: activePlugins,
      };

      requestrunner = await createAssistant(payload);
      setShowAdvancedSettings(false);
      setAdvanceConversationMode(false);
      setNumberOfMessages(0);
      setMessageDelayTime(0);
      setActivePlugins("");
    } else {
      if (e.target.templatename && e.target.templatename?.value === "") {
        alert("Please Enter Template name");
        return true;
      }
      setWaiting(true);

      const payload = {
        name: FormData1.promptName,
        instructions: FormData1.description,
        agency_id: agency._id,
        temperature: contentCreativity,
        model: "openai/gpt-4o",
        top_p: btgen,
        profile_id: agency?.ghl?.location_id,
        readonly: true,
        type: "agency",
        status: false,
        api_type: apiType,
        templatename: e.target.templatename.value,
      };

      requestrunner = await createAssistantTemplate(payload);
    }

    if (requestrunner) {
      onClose();
      setWaiting(false);
    }

    setContentCreativity(1);
    setBtgen(1);
    setpromptstep(0);
    setFormData1([]);
    setPromptQuery("");
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }

    setContentCreativity(tempSliderValue);
  };

  const formatString = (str) => {
    // Replace underscores with spaces
    str = str.replace(/_/g, " ");

    // Add space before each capital letter, ensuring no double spaces
    str = str.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Trim and return the final result
    return str.trim();
  };

  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }
    setBtgen(tempSliderValue);
  };

  const GeneratePrompt = async () => {
    setpromptstep(1);
    try {
      const payload = {
        agency_id: agency._id,
        username: "Agency Prompt Generator",
        promptQuery: promptQuery,
        type: "assistant",
        file_ids: uploadedFileData,
      };

      // "prompts" domain is owned by another fork's queries file - inlined
      // directly rather than touching queries/prompts.js (out of scope here).
      const response = await request(ReqMethods.POST, "/prompts/agency/generate", { payload });

      if (response) {
        setpromptstep(2);
        setFormData1((prevData) => ({
          ...prevData,
          promptName: response?.response?.data?.title || "",
          description: response?.response?.data?.content || "",
        }));
        var temperature = Number(response?.response?.data?.tempratore);
        var top_p = Number(response?.response?.data?.top_p);
        setContentCreativity(temperature);
        setBtgen(top_p);
      }
    } catch (error) {
      return error;
    }
  };
  const handlestep1 = () => {
    if (promptQuery === "") {
      setPromptQueryError(true);
      return false;
    }
    setPromptQueryError(false);
    GeneratePrompt();
  };
  const detectEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      handlestep1();
    }
  };
  const selectassistanttype = (e) => {
    if (e.target.value === "agency" || e.target.value === "automation") {
      setshowStep(false);
      return true;
    }
    if (e.target.value === "account-specific") {
      setapiType("team");
      setshowStep(true);
      return true;
    }
    if (e.target.value === "user-specific") {
      setapiType("user");
      setshowStep(true);
      return true;
    }
  };
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [advanceConversationMode, setAdvanceConversationMode] = useState(false); // State for the toggle button
  const [numberOfMessages, setNumberOfMessages] = useState(0); // State for the first number input field
  const [messageDelayTime, setMessageDelayTime] = useState(0);
  // console.log("toggle Value", messageDelayTime)
  // Toggle Advanced Settings
  const handleAdvancedSettingsClick = () => {
    setShowAdvancedSettings(!showAdvancedSettings);
  };

  // Handle Toggle Button Change
  const handleToggleChange = (event) => {
    setAdvanceConversationMode(event.target.checked);
  };

  // Handle Number Input Change
  const handleNumberInputChange = (event, setter) => {
    setter(event.target.value);
  };

  // Array to store active plugin names
  const [activePlugins, setActivePlugins] = useState([]);
  // console.log("plugins", activePlugins)
  // Handle toggle change for both plugins
  const handlePluginsChange = (event) => {
    const pluginName = pluginsdata.find((plugin) => plugin.name === event.target.name).name;

    // Toggle the ID in the active plugins array
    setActivePlugins((prevState) => {
      if (prevState.includes(pluginName)) {
        // If the ID is already in the active array, remove it
        return prevState.filter((name) => name !== pluginName);
      } else {
        // Otherwise, add it to the active array
        return [...prevState, pluginName];
      }
    });
  };

  useEffect(() => {
    setpromptstep(0);
    setPromptQuery("");
    setFormData1([]);
    if (promptstep > 0) {
      setUploadedFileData([]);
    }
  }, [onClose]);

  const UploadFile = async (files) => {
    try {
      const user = await localforage.getItem("user").then((userObject) => {
        if (userObject) {
          return userObject;
        } else {
          console.log("No user found in localForage");
        }
      });
      console.log(user);
      const formData = new FormData();
      for (let file of files) {
        formData.append("file", file.file);
      }

      const assistantIds = [agency?.assistant_id];
      formData.append("profile_id", agency?.ghl ? agency.ghl.location_id : agency.location_id);
      formData.append("username", "AgencyUser");
      formData.append("model_name", "openai/gpt-4o");
      // formData.append("assistant_ids", JSON.stringify(assistantIds));

      const { response } = await saveAssistantMultimedia(formData, { toaster: true });

      console.log(response, "files for response");

      setUploadedFileData(response.data);
      if (response) {
        setAlertModel(false);
        onLoad();
        setSuccessModel(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeFile = (indexToRemove) => {
    const updatedData = uploadedFileData.filter((_, index) => index !== indexToRemove);
    setUploadedFileData(updatedData);
  };

  return (
    <>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div
            className="p-2 scrollable-modal-content bg-white rounded"
            style={{ position: "relative" }}
          >
            <h2 className="text-black text-left font-14" style={{ fontWeight: "700" }}>
              {" "}
              Create Agent{" "}
            </h2>
            <span className="crossison" onClick={onClose}>
              X
            </span>
            {promptstep == 0 && (
              <>
                <p
                  className="roundofaddprompt z-w-60"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Icon id={"magicstar"} />
                  <AnimatedText
                    text="What do you want your agent to do?"
                    style={{ marginLeft: "20px" }}
                    speed={50}
                  />
                </p>

                <div className="input-container">
                  <textarea
                    value={promptQuery}
                    required
                    placeholder={"Start typing..."}
                    name="promptQuery"
                    onChange={(e) => setPromptQuery(e.target.value)}
                    onKeyDown={(e) => detectEnterPress(e)}
                    className="input_od_addPrompt"
                    style={{
                      width: "100%",
                      padding: "20px", // Add padding as needed
                      borderRadius: "8px", // Adjust border radius as needed
                      maxHeight: "200px",
                      resize: "none", // Prevent manual resizing
                    }}
                    rows={1} // Start with a single row
                    onInput={(e) => {
                      e.target.style.height = "auto"; // Reset height
                      e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
                    }}
                  />

                  <button onClick={handlestep1} className="send-button">
                    <Icon id="sendChat" className="chat__input-icon" />
                  </button>
                </div>
                {promptQueryError && <small style={{ color: "red" }}>Should not be empty</small>}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-start",
                    marginRight: "10px",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid #E5E5E5",
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "5px",
                      width: "fit-content",
                      cursor: "pointer",
                    }}
                    onClick={() => setAlertModel(!alertModel)}
                  >
                    <AttachmentIcon fontSize="20px" />
                  </div>

                  <div>
                    {uploadedFileData?.map((data, index) => {
                      // Extract the file name from the path
                      const fileName = data?.name?.split("/").pop();

                      return (
                        <div
                          key={index}
                          style={{
                            width: "100px",
                            height: "50px",
                            border: "1px solid #ccc",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            margin: "5px",
                            padding: "5px",
                            boxSizing: "border-box",
                            position: "relative",
                          }}
                        >
                          <span style={{ flex: "1", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {fileName.slice(0, 15)}
                          </span>
                          <button
                            onClick={() => removeFile(index)}
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "16px",
                              fontWeight: "bold",
                            }}
                          >
                            &#10005; {/* Unicode Cross Icon */}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
            {promptstep == 1 && (
              <>
                <p
                  className="roundofaddprompt z-w-100 text-center"
                  style={{
                    marginBottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon id={"magicstar"} />
                  <span style={{ display: "inline-block", marginLeft: "10px" }}>
                    Creating Agent
                  </span>
                  <LoadingDots speed={100} />
                </p>
              </>
            )}
            <SoftBox component="form" onSubmit={handleSubmit}>
              {promptstep == 2 && (
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <SoftBox className="mt-2">
                      <label className="text-black">Agent Name</label>
                      <input
                        className="form-control-agust"
                        placeholder="Agent Name"
                        name="assistant_name"
                        onChange={(e) => setFormData1({ ...FormData1, promptName: e.target.value })}
                        defaultValue={FormData1.promptName}
                        required
                      />
                    </SoftBox>
                  </Grid>

                  <Grid item xs={12} style={{ marginTop: "14px" }}>
                    <SoftBox className="mt-2">
                      <label
                        className="text-black"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          width: "fit-content",
                        }}
                      >
                        <span>Purpose</span>

                        <Tooltip
                          PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                maxWidth: "none",
                                width: "400px", // Set your desired width here
                              },
                            },
                          }}
                          placement="top"
                          title={supperAdminData.assistant_purpose}
                        >
                          <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                        </Tooltip>
                      </label>

                      <textarea
                        className="form-control-agust"
                        name="purpose"
                        rows={20}
                        style={{
                          width: "100%",
                          padding: "14px",
                          resize: "vertical",
                        }}
                        value={FormData1.description}
                        onChange={(e) =>
                          setFormData1({ ...FormData1, description: e.target.value })
                        }
                        required
                      />
                    </SoftBox>
                  </Grid>

                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <SoftBox className="mt-2">
                      <label
                        className="text-black"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span>Content Creativity</span>
                        <Tooltip
                          PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                maxWidth: "none",
                                width: "400px", // Set your desired width here
                              },
                            },
                          }}
                          placement="top"
                          title={supperAdminData.content_creativity}
                        >
                          <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                        </Tooltip>
                      </label>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="range"
                          value={contentCreativity}
                          min="0"
                          max="2"
                          step={"0.01"}
                          onChange={handleCCInputChange}
                          className="range-input"
                        />
                        <input
                          type="number"
                          value={contentCreativity}
                          min="0"
                          max="2"
                          step="0.01"
                          onChange={(event) => handleCCInputChange(event)}
                          style={{
                            maxWidth: "50px",
                            fontSize: "14px",
                            margin: "2px",
                            padding: "0px 2px",
                            borderRadius: "5px",
                            border: "1px solid Black",
                          }}
                          className="height_25 bg_transparent removeControl"
                        />
                      </div>
                    </SoftBox>
                  </Grid>

                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <SoftBox className="mt-2">
                      <label
                        className="text-black"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span>Balance Text Generation</span>
                        <Tooltip
                          PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                maxWidth: "none",
                                width: "400px", // Set your desired width here
                              },
                            },
                          }}
                          placement="top"
                          title={supperAdminData.balance_text_generation}
                        >
                          <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                        </Tooltip>
                      </label>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="range"
                          value={btgen}
                          min="0"
                          max="1"
                          step={"0.01"}
                          onChange={handleBtInputChange}
                          className="range-input1"
                        />

                        <input
                          type="number"
                          value={btgen}
                          min="0"
                          max="1"
                          step="0.01"
                          onChange={(event) => handleBtInputChange(event)}
                          style={{
                            maxWidth: "50px",
                            fontSize: "14px",
                            margin: "2px",
                            padding: "0px 2px",
                            borderRadius: "5px",
                            border: "1px solid Black",
                          }}
                          className="height_25 bg_transparent"
                        />
                      </div>
                    </SoftBox>
                  </Grid>
                  {/* Advanced Settings Button */}
                  <SoftBox style={{ width: "100%", textAlign: "right" }} mt={2}>
                    <Button onClick={handleAdvancedSettingsClick} style={{ color: "#000" }}>
                      Advanced Settings
                    </Button>
                  </SoftBox>

                  {showAdvancedSettings && (
                    <div style={{ marginTop: "0px", padding: "10px" }}>
                      <h2
                        className="text-black text-left font-14"
                        style={{ fontWeight: "700", marginBottom: "20px", marginLeft: "-15px" }}
                      >
                        {" "}
                        Advance Setting{" "}
                      </h2>
                      <Grid container spacing={2}>
                        {/* <Grid item xs={12} style={{ marginBottom: '20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>

                              <label className="text-black" style={{ marginRight: '0px' }}>Switch on advanced conversation mode</label>
                              <Tooltip PopperProps={{
                                sx: {
                                  "& .MuiTooltip-tooltip": {
                                    maxWidth: "none",
                                    width: "400px",
                                    marginTop: "30px"
                                  },
                                },
                              }} placement="top" title={supperAdminData.pluginInfo}>
                                <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                              </Tooltip>

                            </div>
                            <div>
                              <Switch
                                checked={advanceConversationMode}
                                onChange={handleToggleChange}
                                name="enableFeature"
                                inputProps={{ 'aria-label': 'Enable Feature' }}
                              />
                            </div>

                          </div>
                        </Grid>

                        <Grid item xs={12} style={{ marginBottom: '15px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label className="text-black">Number of messages</label>
                            <TextField
                              className="numberMessages"
                              type="number"
                              value={numberOfMessages}
                              onChange={(e) => handleNumberInputChange(e, setNumberOfMessages)}
                              fullWidth
                              inputProps={{
                                min: 2,
                                max: 10, // Set max to 10
                                step: 1 // Optional: Only allow whole numbers
                              }}
                              style={{
                                width: '30%',
                                padding: '0 8px',
                                height: '16px !important',
                                fontSize: '14px',
                                lineHeight: '16px',
                              }}
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} style={{ marginBottom: '20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label className="text-black">Delay between messages Seconds:</label>
                            <TextField
                              type="number"
                              value={messageDelayTime}
                              onChange={(e) => handleNumberInputChange(e, setMessageDelayTime)}
                              fullWidth
                              inputProps={{ min: 0 }}
                              style={{
                                width: '30%',
                                padding: '0 8px', // Adjust the padding to match the reduced height
                              }}
                            />
                          </div>
                        </Grid> */}

                        {agency?.default_plugins && (
                          <>
                            <h2
                              className="text-black text-left font-14"
                              style={{ fontWeight: "700", marginBottom: "20px" }}
                            >
                              {" "}
                              Plugins{" "}
                            </h2>
                            {agency?.default_plugins?.map((plugin) => (
                              <Grid item xs={12} style={{ marginBottom: "20px" }} key={plugin.id}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <label className="text-black" style={{ marginRight: "10px" }}>
                                    {formatString(plugin.name).toUpperCase()}
                                  </label>
                                  <Switch
                                    checked={activePlugins.includes(plugin.name)}
                                    onChange={handlePluginsChange}
                                    name={plugin.name}
                                    inputProps={{
                                      "aria-label": `Enable ${formatString(plugin.name)}`,
                                    }}
                                  />
                                </div>
                              </Grid>
                            ))}
                          </>
                        )}
                      </Grid>
                    </div>
                  )}
                  <SoftBox style={{ width: "100%" }} mt={2}>
                    <button
                      className="savebtn-setting w-100 position-relative"
                      type="button"
                      onClick={() => setpromptstep(3)}
                    >
                      Next
                    </button>
                  </SoftBox>
                </Grid>
              )}
              {promptstep == 3 && (
                <>
                  <Grid item xs={12} mt={2}>
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }}>
                      <span>Select type</span>
                    </label>

                    <SoftBox className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                      <select
                        name="assistant_type"
                        onChange={selectassistanttype}
                        className="w-100 selectstyle"
                      >
                        <option value={""}>----Select the type------</option>
                        <option value={"agency"}>All Accounts</option>
                        <option value={"account-specific"}>Account Specific</option>
                        <option value={"user-specific"}>User Specific</option>
                        <option value={"automation"}>Automation</option>
                      </select>
                    </SoftBox>
                  </Grid>

                  {showStep && (
                    <Grid item xs={12} mt={2}>
                      <label className="text-black" htmlFor="for_support">
                        Template name
                      </label>
                      <SoftBox className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <input
                          name="templatename"
                          id="templatename"
                          className="form-control-agust"
                        />
                      </SoftBox>
                    </Grid>
                  )}
                  <SoftBox mt={2}>
                    <button
                      className="savebtn-setting w-100 position-relative"
                      type="submit"
                      disabled={waiting}
                    >
                      {waiting && (
                        <div
                          className="spinner"
                          style={{
                            width: "16px",
                            height: "16px",
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                        ></div>
                      )}
                      Create Agent
                    </button>
                  </SoftBox>
                </>
              )}
            </SoftBox>
          </div>
        </div>
      )}

      {alertModel && (
        <div className="modal-zz" onClick={() => setAlertModel(false)}>
          <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
            <p
              style={{
                position: "absolute",
                right: 5,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={() => setAlertModel(false)}
            ></p>

            <MyDropzone UploadFile={UploadFile} />
          </div>
        </div>
      )}
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function Modal({ products, apps, handleRefresh, supperAdminData, pluginsdata }) {
  const [openAddMember, setOpenAddMember] = useState(false);
  const { mutateAsync: agentBuilderData } = useAgentBuilderData();
  const [agency] = useAgencyInfo();

  const GetAgentBuilderData = async () => {
    try {
      const payload = {
        agency_id: agency._id,
      };

      const response = await agentBuilderData(payload);

      if (response) {
        console.log("Agent Builder Data:", response?.response?.data);

        const agentBuilderId = response?.response?.data?.agentBuilder;
        const userId = response?.response?.data?.user_id;

        // Open as popup window instead of new tab
        // agent-builder has no login/token of its own - it's an Agency-
        // session tool, so it borrows this session's token via the URL.
        const token = await localforage.getItem("token");
        window.open(
          `${env.AGENT_BUILDER_URL}agency_id=${agency._id}&token=${token}`,
          "agentBuilder",
          "width=1000,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=no"
        );
      }
    } catch (error) {
      return error;
    }
  };

  return (
    <div style={{ textAlign: "right" }}>
      <button onClick={GetAgentBuilderData} className="btn btn-outline-dark">
        Create Agent
      </button>

      {/* <button className="btn btn-outline-dark" onClick={() => setOpenAddMember(true)}>
        Create Agent
      </button> */}
      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        products={products}
        apps={apps}
        handleRefresh={handleRefresh}
        supperAdminData={supperAdminData}
        pluginsdata={pluginsdata}
      />
    </div>
  );
}

Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};

export default Modal;
